window.addEventListener('DOMContentLoaded', () => {
  const fairRegionInput = document.querySelector('#fair-region')
  const regions = document.querySelectorAll('.region')

  fairRegionInput.addEventListener('change', (e) => {
    console.log(e.target.value)
    regions.forEach((el) => {
      if (e.target.value === '全国') {
        el.style.display = 'block'
      } else {
        if (el.dataset.regionName === e.target.value) {
          el.style.display = 'block'
        } else {
          el.style.display = 'none'
        }
      }
    })
  })
})
